<template>
    <b-card no-body>
        <b-tabs card>
            <b-tab
                :active="currentTabName === 'interview'"
                @click="onTabClick('interview', $event)">
                <template slot="title">
                    <b-icon-file-earmark-text></b-icon-file-earmark-text> {{ $locale.question }}
                </template>
                <b-container>
                    <div class="c-box-scroll c-box-scroll--500">
                        <user-interview-answers
                              :consultation-id="consultation.id"
                              :is-only-content="1"
                              :flg-reserved-by-doctor="consultation.flg_reserved_by_doctor">
                        </user-interview-answers>
                    </div>
                </b-container>
            </b-tab>

            <b-tab
                :active="currentTabName === 'chat'"
                :title-item-class="tabCSS.chat"
                @click="onTabClick('chat', $event)">
                <template slot="title">
                    <b-icon-chat-dots-fill></b-icon-chat-dots-fill> チャット
                </template>
                <b-container>
                    <div class="pb-5">
                        <user-chat
                            :consultation="consultation"
                            :timezone="timezone"
                            :is-active="currentTabName === 'chat'"
                            is-only-content>
                        </user-chat>
                    </div>
                </b-container>
            </b-tab>

            <b-tab
                :active="currentTabName === 'image'"
                :title-item-class="tabCSS.image"
                @click="onTabClick('image', $event)">
                <template slot="title">
                    <svg class="b-tab-icon-camera" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve">
                        <g>
                            <path d="M8,5.6c-1.7,0-3,1.4-3,3s1.4,3,3,3s3-1.4,3-3S9.7,5.6,8,5.6z"/>
                            <path d="M14.4,4.4h-2.1l-1-2.5H4.8l-1,2.5H3.5V3.1H2v1.3H1.7C1,4.4,0.5,4.9,0.5,5.6V13c0,0.7,0.6,1.2,1.2,1.2h12.7
                            c0.7,0,1.2-0.6,1.2-1.2V5.6C15.6,4.9,15,4.4,14.4,4.4z M3,4.4H2.5V3.6H3V4.4z M8,13.2c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5
                            s4.5,2,4.5,4.5S10.5,13.2,8,13.2z M13.5,7.4c-0.6,0-1-0.5-1-1s0.5-1,1-1s1,0.5,1,1S14.1,7.4,13.5,7.4z"/>
                        </g>
                    </svg>撮影画像
                </template>
                <b-container class="c-box-scroll c-box-scroll--500">
                    <user-consultation-images
                          :consultation-id="consultation.id"
                          :is-only-content="true">
                    </user-consultation-images>
                </b-container>
            </b-tab>

            <b-tab
                :active="currentTabName === 'attached_image'"
                :title-item-class="tabCSS.attached_image"
                @click="onTabClick('attached_image', $event)">
                <template slot="title">
                    <b-icon-images></b-icon-images> 添付画像
                </template>
                <b-container class="c-box-scroll c-box-scroll--500">
                    <user-consultation-attached-images
                            :consultation-id="consultation.id"
                            :is-only-content="1">
                    </user-consultation-attached-images>
                </b-container>
            </b-tab>

            <b-tab
                :active="currentTabName === 'medical_record'"
                :title-item-class="tabCSS.medical_record"
                @click="onTabClick('medical_record', $event)">
                <template slot="title">
                    <b-icon-clipboard-data></b-icon-clipboard-data> {{ `${$locale.consultation_host}記録` }}
                </template>
                <b-container>
                    <div v-if="consultation.medical_record && consultation.medical_record.published_at">
                        <medical-record-viewer :medical-record="consultation.medical_record"/>
                    </div>
                    <div v-else>
                        <p class="mb-0 text-muted">記録がまだ公開されていません。</p>
                    </div>
                </b-container>
            </b-tab>
        </b-tabs>

        <image-modal/>
        <delete-file-modal user-type="user"/>
    </b-card>
</template>

<script>
    import constants from '../../constants'

    export default {
        props: [
            'timezone',
            'consultation',
            'interview_answer',
        ],

        data: function () {
            return {
                images: [],
                tabCSS: {
                    chat: '',
                    image: '',
                    attached_image: '',
                    medical_record: '',
                },
                currentTabName: 'interview',
            }
        },

        computed: {
            /**
             * URLクエリパラメータ action
             * @return {string|null}
             */
            queryAction: function () {
                return this.$route.query.action
            },
        },

        created: function() {
            bus.$on('update-tab-css', this.updateTabCSS)
            bus.$on('focus-chat-send-message', this.focusChatMessageTextArea)
        },

        mounted: function () {
            this.initCurrentTab()
        },

        beforeDestroy: function () {
            bus.$off('update-tab-css')
            bus.$off('focus-chat-send-message')
        },

        methods: {
            /**
             * 初期表示タブ
             * @see resources/js/components/user/UserDeeplinkHandle.vue
             */
            initCurrentTab: function () {
                if (!this.queryAction) return

                if (this.queryAction.includes('interview')) {
                    this.currentTabName = 'interview'
                }
                else if (this.queryAction.includes('chat')) {
                    this.currentTabName = 'chat'
                    this.initChat()
                }
                else if (this.queryAction.includes('attached_image')) {
                    this.currentTabName = 'attached_image'
                }
                else if (this.queryAction.includes('image')) {
                    this.currentTabName = 'image'
                }
                else if (this.queryAction.includes('medical_record')) {
                    this.currentTabName = 'medical_record'
                }
            },

            updateTabCSS: function (tabName, exists) {
                this.tabCSS[tabName] = exists ? 'b-tab-content-exists-user' : ''
            },

            onTabClick: function (tabName, e) {
                if (e && e.target && e.target.closest('a.nav-link')) {
                    this.currentTabName = tabName

                    if (tabName === 'chat') {
                        this.initChat()
                    }
                }
            },

            initChat: function () {
                this.$nextTick(() => {
                    this.focusChatMessageTextArea()
                    bus.$emit('chat-scroll')
                })
                this.readMessages()
            },

            /**
             * チャットメッセージ既読化
             */
            readMessages: function () {
                axios.put(`${constants.user.consultations.endpoint.base}/${this.consultation.id}/message_read`)
            },

            focusChatMessageTextArea: function () {
                document.getElementById('chat_message_textarea').focus()
            },
        },
    }
</script>
